import Lms from 'components/widgets/Lms/lms';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { LmsTopHeader } from 'components/widgets/Lms/Components/lmsTopHeader/lmsTopHeader';
import { excellenceAppsConfig } from 'components/Dashboards/ExcellenceApps/excellenceAppsConfig';
import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { MainContent } from 'components/common/PageContainer/MainContent';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';

const LmsPage = () => {
    useFullStoryPageView({ pageName: excellenceAppsConfig.learningMaterials.title });
    return (
        <PageContainer>
            <HeaderWrapper>
                <LmsTopHeader />
            </HeaderWrapper>

            <MainContent>
                <Lms />
            </MainContent>
        </PageContainer>
    );
};
export default LmsPage;
